import React from 'react';
import { Skeleton } from '../../ui';

const Row: React.FC = () => (
    <div className="flex items-center gap-[14px] border-t border-line-divider-soft py-[12px]">
        <Skeleton shape="block" width={32} height={32} />
        <span className="flex flex-1 flex-col gap-[7px]">
            <Skeleton width="34%" height={12} />
            <Skeleton width="58%" height={10} />
        </span>
        <Skeleton width={70} height={22} />
        <Skeleton width={90} height={22} />
    </div>
);

/** Opening step 5: the stored recommendation's shape — a headline, then supplier rows. */
const RecommendationSkeleton: React.FC = () => (
    <div data-testid="recommendation-skeleton" aria-busy="true" className="rounded-card border border-line bg-surface px-s6 py-[18px]">
        <div className="flex flex-col gap-[9px] pb-[14px]">
            <Skeleton width="42%" height={16} />
            <Skeleton width="76%" height={11} />
            <Skeleton width="60%" height={11} />
        </div>
        <Row />
        <Row />
        <Row />
    </div>
);

export default RecommendationSkeleton;
